import { CustomValidateUrl } from './components/urls/url.validator';
import { CustomValidateEquals } from './components/equals/equals.validator';
import { CustomValidateInArray } from './components/in-arrray/in-array.validator';
import { CustomOnlyText } from './components/only-text/only-text.validator';
import { CustomOnlyNumbers } from './components/only-numbers/only-numbers.validator';
import { CustomLength } from './components/length/length.validator';
import { CustomRequired } from './components/required/required-validator';
import { CustomMinLength } from './components/min-length/min-length.validator';
import { CustomMaxLength } from './components/max-length/max-length.validator';
import { CustomValidateRequiredLocation } from './components/required-location/required-location.validator';
import { CustomValidateDate } from './components/date/date.validator';
import { CustomIsAMinor } from './components/is-a-minor/is-a-minor.validator';
import { CustomRegExp } from './components/reg-exp/reg-exp.validator';
import { CustomInteger } from './components/integer/integer-validator';
import { CustomOperators } from './components/operators/operators.validator';
import { CustomInvalid } from './components/invalid/invalid.validator';


export const CustomValidators = {
  _name: 'CustomValidators',
  _nameSplit: 'CustomValidators.',
  _isProperty: 'Property.',
  url: CustomValidateUrl,
  equals: CustomValidateEquals,
  inArray: CustomValidateInArray,
  required: CustomRequired,
  onlyText: CustomOnlyText,
  onlyNumbers: CustomOnlyNumbers,
  length: CustomLength,
  minLength: CustomMinLength,
  maxLength: CustomMaxLength,
  requiredLocation: CustomValidateRequiredLocation,
  date: CustomValidateDate,
  isAMinor: CustomIsAMinor,
  regExp: CustomRegExp,
  integer: CustomInteger,
  operators: CustomOperators,
  invalid: CustomInvalid
};



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/index.ts